const DEFAULT_PLACEHOLDER = '/imgs/no_photo.jpg';

function imageFallbackSource(current, original, placeholder = DEFAULT_PLACEHOLDER) {
  if (!current) return placeholder || null;
  if (placeholder && current.endsWith(placeholder)) return null;

  if (original) {
    try {
      const source = new URL(original, current);
      if (['http:', 'https:'].includes(source.protocol) && source.href !== current) {
        return source.href;
      }
    } catch (error) {
      return placeholder || null;
    }
  }

  return placeholder || null;
}

function applyImageFallback(event, original, placeholder) {
  const image = event && event.target;
  if (!image) return false;
  const fallback = imageFallbackSource(image.src, original, placeholder);
  if (!fallback) return false;
  image.src = fallback;
  return true;
}

module.exports = { DEFAULT_PLACEHOLDER, imageFallbackSource, applyImageFallback };
